export const SENTRY_URL = 'https://sentry.io';
